/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useCallback, useEffect, useRef, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import * as Styles from '../../../Maintain/client/Components/StyleConstant';
import { dateComparator } from '../../../Reports/InvoiceRegister/Components/gridComponents/tableHead';
import {
  amountComparator,
  cellRenderer,
  cellRendererSixDec,
  comparatorQtr,
} from '../../../../SharedModules/utilities/utilities';

const CalculatedInterestQuarterDetailsTable = ({
  fullScreen,
  setFullScreen,
}) => {
  const MAN_HEAD = [
    {
      headerName: 'Quarter',
      field: 'drugInterestQtr',
      editable: false,
      minWidth: 160,
      maxLength: Styles.Length_255,
      comparator: comparatorQtr,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      cellStyle: { 'border-right-color': Styles.BorderColor },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Interest Begin Date',
      field: 'interestCalculationBeginDt',
      minWidth: 160,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      comparator: dateComparator,
      editable: false,
      cellStyle: { 'border-right-color': Styles.BorderColor },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Interest Activity',
      field: 'descr',
      minWidth: 250,
      editable: false,
      maxLength: Styles.Length_255,
      cellStyle: { 'border-right-color': Styles.BorderColor },
      cellRenderer: 'InterestActivityCellRender',
      cellClass: 'frr-ellipsis-text',
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'URA',
      field: 'unitRebateAmt',
      editable: false,
      minWidth: 280,
      comparator: amountComparator,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,

      isTextColorRed: true,
      dataAlignRight: true,
      excelAlignment: 'right',

      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Total Units',
      field: 'numOfUnits',
      minWidth: 160,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      comparator: amountComparator,
      autoHeaderHeight: true,
      editable: false,
      isTextColorRed: true,
      dataAlignRight: true,
      excelAlignment: 'right',

      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Principal Due',
      field: 'principalAmt',
      minWidth: 280,
      editable: false,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      cellRenderer: cellRenderer,
      comparator: amountComparator,
      printPrefixValue: '$',
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Pre Quarter Interest',
      field: 'prevQtrInterestAmt',
      minWidth: 320,
      editable: false,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      cellRenderer: cellRenderer,
      comparator: amountComparator,
      printPrefixValue: '$',
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Rate',
      field: 'interestRate',
      minWidth: 280,
      editable: false,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      cellRenderer: cellRendererSixDec,
      comparator: amountComparator,
      printPrefixValue: ' ',
      exportZeroSix: true,
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Current Interest',
      field: 'interestCalculatedAmt',
      minWidth: 320,
      editable: false,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      cellRenderer: cellRenderer,
      comparator: amountComparator,
      printPrefixValue: '$',
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
  ];
  const [tableCount, setTableCount] = useState(0);
  const [gridApi, setGridApi] = useState(null);
  const gridData = useSelector(
    (state) =>
      state?.sharedState?.CalculatedInterestReducer.drugInterestResponse
  );

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);
  useEffect(() => {
    resetFilters();
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
    const resData = [];
  }, [gridApi]);

  const resetFilters = () => {
    gridApi && gridApi.setFilterModel(null);
  };
  const [selectedRow, setSelectedRow] = useState(null);
  const [applyFilter, setApplyFilter] = useState(false);
  const onSelectionChanged = useCallback(() => {}, [gridApi]);
  const handleFullScreenView = () => {
    setFullScreen(!fullScreen);
  };
  return (
    <div className="tabs-container tBillPanel custom-check">
      <div className="table-container p-0 eightRecords col-12 no-border">
        <TableGridWithFeatures
          data-testid="CAL-MFG-table"
          fullScreenView={fullScreen}
          handleFullScreenViewClick={handleFullScreenView}
          gridHeight={fullScreen ? '100vh' : 350}
          onGridReady={onGridReady}
          rowData={gridData}
          columnDefs={MAN_HEAD}
          exportFile
          sideBar={false}
          onFilterChanged={(e) => {
            setTableCount(e.api?.getDisplayedRowCount());
            if (
              (e.api.getFilterModel() && Object.keys(e.api.getFilterModel()))
                .length > 0
            ) {
              setApplyFilter(true);
            } else {
              setApplyFilter(false);
            }
          }}
          singleClickEdit={false}
          fileName="Calc Interest Details - NDC"
          onSelectionChanged={onSelectionChanged}
          frameworkComponents={{
            InterestActivityCellRender: (cellInfo) => {
              const name = cellInfo?.data?.descr;
              if (name && name.length > 24) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name }</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
          }}
        />
      </div>
    </div>
  );
};
export default CalculatedInterestQuarterDetailsTable;
